import styled from 'styled-components';
import { mediumBreakpoint } from 'utilities/constants';

export const MockImage = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  width: 40%;
  display: inline-block;

  img {
    max-height: 400px;
    max-width: 100%;
    /* display: inline-block; */
    /* vertical-align: top; */

    @media (max-width: ${mediumBreakpoint}px) {
      padding: 0 0.5rem;
    }
  }
`;

export const LottieContainer = styled.div`
  @media (max-width: ${mediumBreakpoint}px) {
    display: contents;
    padding: 0;
  }

  [role='button'] {
    cursor: default;
  }
`;
